import { Fonts, Metrics } from "Themes";

import styled from "styled-components";

export const ProfileContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
`;

export const ProfilePictureContainer = styled.div`
  border-radius: 5px;
  padding: 1px;
  display: flex;
  justify-content: center;
`;

export const ProfileDetailsContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ProfileDetailsText = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  font-family: ${Fonts.primaryFontFamily};
  font-size: ${Fonts.fontSize.medium}px;
`;

export const ContactContainer = styled.div`
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
  &:hover {
    background-color: lightgray;
  }
`;

export const ProjectNumberContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 10px;
  font-family: ${Fonts.primaryFontFamily};
  font-size: ${Fonts.fontSize.medium}px;
`;

const styles = {
  personalDetailsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "70%",
    margin: "auto",
    marginBottom: Metrics.margin.small,
    paddingBottom: Metrics.padding.small
  },
  personalDetails: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  personalDetailsImage: {
    flex: 1,
    border: "solid 2px lightgray",
    borderRadius: "5px",
    padding: "10px"
  },
  personalDetailsText: {
    flex: 4,
    textAlign: "center"
  },
  profileAvatar: {
    height: "100px",
    width: "100px",
    borderRadius: "5px"
  },
  sendMessageIcon: {
    height: "20px",
    width: "20px",
    cursor: "pointer"
  },
  verifiedCheck: {
    color: "green",
    opacity: 0.5,
    fontSize: 30,
    cursor: "pointer"
  },
  showVerifiedHide: {
    opacity: 0
  },
  showVerified: {
    border: "solid 2px lightgrey",
    borderRadius: "5px",
    padding: "5px"
  },
  profileButtons: {
    display: "flex",
    width: "50%",
    padding: "10px",
    borderRadius: "5px"
  }
};

export default styles;
